import { Icon } from "@zapier/zinnia-icons";
import { Tag, Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";

import { useSize } from "@zapier/reporting/src/hooks/useSize";
import { getTooltipPosition, pillOverride } from "../indicatorStyles";

/**
 * Replay indicator icon with tooltip, displayed when a run has been replayed.
 */
function ReplayIndicator({ replayCount }: { replayCount: number }) {
  const size = useSize();

  const tooltipText =
    replayCount === 1
      ? "Run has been replayed once"
      : `Run has been replayed ${replayCount} times`;

  return (
    <Tooltip content={tooltipText} placement={getTooltipPosition(size)}>
      <TooltipFocusableTrigger>
        <div css={pillOverride} data-testid="replay-indicator">
          <Tag variant="UiPrimaryWeaker" size="x-small">
            <Icon color="UiPrimaryStrongest" name="actionAutoRenew" size={16} />
          </Tag>
        </div>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default ReplayIndicator;
